<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Críticas</h2>
    </div>

    <div class="tds-row">
        <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
            <tds-table-toolbar filter>
                 <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                    <tds-button variant="secondary" size="sm" title="Inserir">
                        <tds-icon slot="icon" class="tds-btn-icon" size="18px" name="plus"></tds-icon>
                    </tds-button>
                 </div>
            </tds-table-toolbar>
            <tds-table-header>
                <tds-header-cell cell-key="actions"></tds-header-cell>
                <tds-header-cell cell-key='coD_ORIGINAL' cell-value='Código' sortable></tds-header-cell>
                <tds-header-cell cell-key='descr' cell-value='Descrição' sortable></tds-header-cell>
            </tds-table-header>
            <tds-table-body>
                <tds-table-body-row>
                    <tds-body-cell cell-key="actions">
                        <div class="action-buttons" title="Excluir">
                            <tds-icon id="edit" name="cross" size="20px" style="cursor: pointer;" ></tds-icon>
                        </div>
                    </tds-body-cell>
                    <tds-body-cell cell-key="coD_ORIGINAL">12344</tds-body-cell>
                    <tds-body-cell cell-key="descr">PAVI E NUNES TRANSPORTE LTDA - ME</tds-body-cell>
                </tds-table-body-row>
            </tds-table-body>
        </tds-table>
    </div>
</div>